export const usePaginatedConsultations = ({ consultations, searchTerm, searchFields, page, rowsPerPage }) => {
  const filtered = (consultations ?? []).filter((c) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return searchFields.some((getField) => {
      const value = getField(c);
      return value?.toString().toLowerCase().includes(term);
    });
  });

  const total = filtered.length;
  const totalPages = Math.ceil(total / rowsPerPage);
  const start = (page - 1) * rowsPerPage + 1;
  const end = Math.min(page * rowsPerPage, total);
  const paginated = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return { filtered, paginated, total, totalPages, start, end };
};
